import {twMerge} from 'tailwind-merge';
import {t} from 'ttag';

const PageErrorBoundary = () => {
    return (
        <div className={twMerge('flex flex-col m-auto')}>
            <h2>{t`UI Error`}</h2>
            <hr />
            <div className="mt-2">{t`We apologize, the UI encountered an error.`}</div>
            <div>{t`Please try again later. If you still experience issues, please contact our support team.`}</div>
        </div>
    );
};
export default PageErrorBoundary;
